module.exports = __webpack_public_path__ + "img/game_icon_penalty.afeb5492.png";